var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeitrgeWeiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.5 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tags",
    className: "cls-1",
    d: "M21.4,9.71L12.29,.6C11.9,.21,11.38,0,10.83,0H2.06C.92,0,0,.92,0,2.06h0V10.83c0,.55,.21,1.07,.6,1.46l9.1,9.1c.81,.81,2.11,.81,2.92,0h0l8.78-8.77c.81-.81,.81-2.11,0-2.92ZM4.81,6.88c-1.14,0-2.06-.92-2.06-2.06,0-1.14,.92-2.06,2.06-2.06,1.14,0,2.06,.92,2.06,2.06,0,1.14-.92,2.06-2.06,2.06h0Zm22.09,5.75l-8.77,8.77c-.81,.81-2.11,.81-2.92,0h0l-.02-.02,7.48-7.49c1.51-1.51,1.51-3.96,0-5.47h0L14.24,0h2.09c.55,0,1.07,.21,1.46,.6l9.1,9.1c.81,.81,.81,2.11,0,2.92h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeitrgeWeiss);
export default __webpack_public_path__ + "static/media/Beiträge_weiss.fe715d5a74b16c6b60e5e64e5ee91da7.svg";
export { ForwardRef as ReactComponent };